import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/landing';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'gold' | 'light';
  className?: string;
};
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'md',
  variant = 'gold',
  className = ''
}: CtaButtonProps) {
  const sizes = size === 'lg' ? 'px-6 py-4 text-sm sm:px-8 sm:py-5 sm:text-base md:text-lg' : 'px-5 py-3.5 text-[13px] sm:px-7 sm:py-4 sm:text-sm md:text-base';
  const variants = variant === 'gold' ? 'bg-gold text-white hover:bg-gold-dark focus-visible:ring-gold' : 'bg-gold-bright text-ink hover:bg-gold-soft focus-visible:ring-gold-bright';
  return <a href={href} className={`group inline-flex w-full items-center justify-center gap-2.5 rounded-full text-center font-black uppercase leading-snug tracking-wide shadow-[0_10px_30px_-12px_rgba(139,100,33,0.6)] transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-cream sm:w-auto sm:gap-3 ${sizes} ${variants} ${className}`} data-id="element-42" data-mp="vdd9xcw9ab9k">
      <span data-id="element-43" data-mp="3ex2sc0gggp71">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-44" data-mp="3ezxb7njtm1yc" />
    </a>;
}